import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "serp__filter-dropdown-list--container q-container-fluid q-pb-2 q-d-flex"
}
const _hoisted_2 = { class: "serp__filter-dropdown-list q-justify-content-start q-d-flex q-flex-wrap q-col-12" }

import FilterDropdown from "@/components/SerpPage/FiltersContainer/FiltersList/FilterDropdown.vue";
import ClearFiltersButton from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue"
import SortingButtonDropDown from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButtonDropDown.vue"
import {storeToRefs} from "pinia";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersDropdownsList',
  setup(__props) {

const filtersStore = useFiltersStore();



const {getFilters} = storeToRefs(filtersStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)



return (_ctx: any,_cache: any) => {
  return (!_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_unref(noResultsState))
            ? (_openBlock(), _createBlock(SortingButtonDropDown, { key: 0 }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getFilters), (filter) => {
            return (_openBlock(), _createBlock(FilterDropdown, {
              key: filter.field,
              filter: filter
            }, null, 8, ["filter"]))
          }), 128)),
          _createVNode(ClearFiltersButton)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})